import { useTranslation } from 'next-i18next'

import SVGIcon from '~/components/Icons/svgs/SVGIcon'

import { LeaderboardData } from '~/Leaderboard/types/leaderboard.types'
import ArrowDownBoldIcon from '~/components/Icons/svgs/ArrowDownBoldIcon'

export default function DemoteLine({
  index,
  leaderboardData,
}: {
  index: number
  leaderboardData: LeaderboardData
}): React.ReactElement {
  const { t } = useTranslation('leaderboard')
  const isAnyoneStying =
    leaderboardData?.leaderboardCapacity -
    leaderboardData?.promotionSettings?.demote -
    leaderboardData?.promotionSettings?.promote
  const isDemotion = index === leaderboardData?.leaderboardCapacity - leaderboardData?.promotionSettings?.demote

  if (isDemotion) {
    return (
      <div
        className={`flex justify-center items-center py-6 gap-2 text-lg font-semibold ${
          isAnyoneStying ? 'border-t border-white mt-6' : ''
        } text-red`}
      >
        <SVGIcon icon={ArrowDownBoldIcon} pathClassName="text-red" />
        {t('leagueDemotion')}
        <SVGIcon icon={ArrowDownBoldIcon} pathClassName="text-red" />
      </div>
    )
  }

  return <></>
}
